import React, { useCallback } from "react";
import { useIntl } from "react-intl";
import Switch from "../../../../../../../library/UI/Switch";
import "./ChartSettings.sass";

/**
 * "Settings" section inside ChartTypeMenu.
 * Shows three toggle rows: timer, autoscroll, grid snap (switch left of the label, as in PO).
 *
 * @param {object}   props
 * @param {boolean}  props.isTimerAvailable - false hides the timer row (Line chart)
 * @param {boolean}  props.timerEnabled
 * @param {boolean}  props.autoscrollEnabled
 * @param {boolean}  props.gridSnapEnabled
 * @param {Function} props.onTimerChange       - () => void
 * @param {Function} props.onAutoscrollChange  - () => void
 * @param {Function} props.onGridSnapChange    - () => void
 */
const ChartSettings = ({
  isTimerAvailable,
  timerEnabled,
  autoscrollEnabled,
  gridSnapEnabled,
  onTimerChange,
  onAutoscrollChange,
  onGridSnapChange,
}) => {
  const intl = useIntl();
  const t = useCallback((id) => intl.formatMessage({ id }), [intl]);

  return (
    <div className="chart-settings">
      {isTimerAvailable && (
        <div className="chart-settings__row">
          <Switch
            id="chart-settings-timer"
            checked={timerEnabled}
            onChange={onTimerChange}
          />
          <label
            htmlFor="chart-settings-timer"
            className="chart-settings__label"
          >
            {t("futures.chart.type_menu.enable_timer")}
          </label>
        </div>
      )}

      <div className="chart-settings__row">
        <Switch
          id="chart-settings-autoscroll"
          checked={autoscrollEnabled}
          onChange={onAutoscrollChange}
        />
        <label
          htmlFor="chart-settings-autoscroll"
          className="chart-settings__label"
        >
          {t("futures.chart.type_menu.enable_autoscroll")}
        </label>
      </div>

      <div className="chart-settings__row">
        <Switch
          id="chart-settings-grid-snap"
          checked={gridSnapEnabled}
          onChange={onGridSnapChange}
        />
        <label
          htmlFor="chart-settings-grid-snap"
          className="chart-settings__label"
        >
          {t("futures.chart.type_menu.enable_grid_snap")}
        </label>
      </div>
    </div>
  );
};

export default ChartSettings;
